import {Exclude, Expose} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class BodyGenApiModel extends AbstractDictionaryApiModel {
  @Expose() public yearFrom: string;
  @Expose() public yearTo: string;
}
